<!-- SECTION PAGE 8 Start-->
<!-- <section class="container-fluid ms-main-bg py-5"> -->
    <div class="container ms-pg-structure my-5 p-0">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h main-heading year-calendar-title">{{"التقويم الزمني للدورات والورش لعام" | translator}} {{formatYear()}}م</h4>
            </div>
        </div>

        <div class="white-box">
            <div class="d-flex justify-content-center">
              <div class="year-calendar-container">
                <!-- Year Navigation -->
                <div class="d-flex justify-content-between align-items-center mb-4">
                  <button class="ms-btn-onclick my-2" (click)="prevYear()" [disabled]="isLoading"><b>{{'Previous Year' | translator}}</b></button>
                  <h2 class="my-2 t-main-b">{{ formatYear() }}</h2>
                  <button class="ms-btn-onclick my-2" (click)="nextYear()" [disabled]="isLoading"><b>{{'Next Year' | translator }}</b></button>
                </div>
                
                <!-- Loading Spinner -->
                <div class="calendar-loader-container" *ngIf="isLoading">
                  <p-progressSpinner styleClass="calendar-spinner" strokeWidth="4" animationDuration="1s"></p-progressSpinner>
                  <p class="loading-text">{{ 'Loading calendar data...' | translator }}</p>
                </div>
                
                <!-- Year Calendar Grid: 2 rows x 6 columns -->
                <div class="year-calendar-grid" *ngIf="!isLoading && yearCalendarData.length > 0 && zoomedMonthIndex === null">
                  <div *ngFor="let monthData of yearCalendarData; let i = index" class="month-calendar-wrapper">
                    <!-- Month Header -->
                    <div class="month-header" [ngClass]="'month-header-' + getMonthHeaderColor(i)" (click)="toggleZoomMonth(i)">
                      <h3 class="month-name">{{ monthData.monthName | translator }}</h3>
                      <i class="pi pi-search-plus zoom-icon"></i>
                    </div>
                    
                    <!-- Days of Week Header -->
                    <div class="month-days-header">
                      <div class="calender-day-box-small" *ngFor="let day of daysOfWeek">{{ day | translator }}</div>
                    </div>
                    
                    <!-- Calendar Grid for this month -->
                    <div class="month-calendar-grid">
                      <div *ngFor="let week of monthData.calendarData" class="d-flex justify-content-start flex-wrap week-row">
                      <div *ngFor="let dayData of week" 
                             [ngClass]="{'negative-day': dayData._id.day <= 0, 'has-trainings': dayData.data?.length > 0}" 
                             (click)="getModalData(dayData);" 
                             class="calender-number-box-small">
                          <div class="calender-postition-number-small" [hidden]="dayData._id.day<=0">{{ dayData._id.day }}</div>
                          <div class="ms-flex-column-small">
                            <div class="calender-training-topic-small" *ngFor="let training of dayData.data">
                              <i class="training-icon" [ngClass]="getTrainingIcon(training)"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Zoomed Month View -->
                <div class="zoomed-month-container" *ngIf="!isLoading && zoomedMonthIndex !== null && yearCalendarData[zoomedMonthIndex]">
                  <div class="zoomed-month-header">
                    <button class="ms-btn-onclick back-btn" (click)="closeZoomedMonth()">
                      <i class="pi pi-arrow-right"></i>
                      <span>{{'Back to Year View' | translator}}</span>
                    </button>
                    <h2 class="zoomed-month-title">{{ yearCalendarData[zoomedMonthIndex].monthName | translator }} {{ formatYear() }}</h2>
                    <div class="month-navigation">
                      <button class="ms-btn-onclick nav-btn" (click)="toggleZoomMonth(zoomedMonthIndex - 1)" [disabled]="zoomedMonthIndex <= 0">
                        <i class="pi pi-chevron-right"></i>
                      </button>
                      <button class="ms-btn-onclick nav-btn" (click)="toggleZoomMonth(zoomedMonthIndex + 1)" [disabled]="zoomedMonthIndex >= 11">
                        <i class="pi pi-chevron-left"></i>
                      </button>
                    </div>
                  </div>
                  
                  <div class="zoomed-month-wrapper" [ngClass]="'zoomed-month-' + getMonthHeaderColor(zoomedMonthIndex)">
                    <!-- Days of Week Header -->
                    <div class="zoomed-days-header">
                      <div class="zoomed-day-box" *ngFor="let day of daysOfWeek">{{ day | translator }}</div>
                    </div>
                    
                    <!-- Calendar Grid for zoomed month -->
                    <div class="zoomed-calendar-grid">
                      <div *ngFor="let week of yearCalendarData[zoomedMonthIndex].calendarData" class="zoomed-week-row">
                        <div *ngFor="let dayData of week" 
                             [ngClass]="{'negative-day': dayData._id.day <= 0, 'has-trainings': dayData.data?.length > 0}" 
                             (click)="getModalData(dayData);" 
                             class="zoomed-number-box">
                          <div class="zoomed-day-number" [hidden]="dayData._id.day<=0">{{ dayData._id.day }}</div>
                          <div class="zoomed-trainings-container">
                            <div class="zoomed-training-item" *ngFor="let training of dayData.data; let idx = index">
                              <i class="training-icon" [ngClass]="getTrainingIcon(training)"></i>
                              <span class="training-title" *ngIf="idx < 2">
                                {{ training.trainingDetails?.title ? (training.trainingDetails.title | slice:0:15) : (training.topic | slice:0:15) }}{{ (training.trainingDetails?.title?.length > 15 || training.topic?.length > 15) ? '...' : '' }}
                              </span>
                            </div>
                            <div class="more-trainings" *ngIf="dayData.data?.length > 2">
                              +{{ dayData.data.length - 2 }} {{'more' | translator}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

       

    </div>


    <p-dialog 
      header="{{'Training Calendar' | translator}} - {{ modalData?._id?.day }}/{{ modalData?._id?.month }}/{{ modalData?._id?.year }}" 
      [(visible)]="showDilogue" 
      [modal]="true" 
      [style]="{ width: '90vw' , maxWidth:'1200px' }" 
      [draggable]="false" 
      [resizable]="true"
      [styleClass]="'training-calendar-modal'">
      <div class="container-fluid ms-bg-modal">
        <div *ngIf="modalData?.data && modalData.data.length > 0; else noTrainings">
          <div class="modal-training-item" *ngFor="let data of modalData.data;let i = index" (click)="showTrainingDetail(data)">
            <div class="modal-item-number">{{i+1}}</div>
            <div class="modal-item-content">
              <ng-container *ngIf="userProfileFlag">
                <div class="modal-item-title">{{data?.title}}</div>
                <div class="modal-item-status" [ngClass]="data.request_id?.status">
                  {{data.request_id?.status | translator}}
                </div>
              </ng-container>
              <ng-container *ngIf="!userProfileFlag">
                <div class="modal-item-title">{{ data.trainingDetails?.title ? data.trainingDetails.title : data.topic }}</div>
                <div class="modal-item-ou" *ngIf="data?.ou?.name">{{data.ou.name}}</div>
                <div class="modal-item-status" [ngClass]="data.status">
                  {{data.status | translator}}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <ng-template #noTrainings>
          <div class="no-trainings-message">
            <i class="pi pi-calendar-times"></i>
            <p>{{ 'No trainings scheduled for this date' | translator }}</p>
          </div>
        </ng-template>
      </div>
    </p-dialog>
<!-- </section>  -->
<!-- SECTION PAGE 8 End -->